export interface UnknownApiErrorOptions {
  status?: number
  url?: string | null
  code?: string
  serverMessage?: string
}

export class UnknownApiError extends Error {
  readonly status?: number
  readonly url?: string
  readonly code?: string
  readonly serverMessage?: string

  constructor(options?: UnknownApiErrorOptions) {
    super(buildMessage(options))
    Object.setPrototypeOf(this, UnknownApiError.prototype)
    this.status = options?.status
    this.url = options?.url ?? undefined
    this.code = options?.code
    this.serverMessage = options?.serverMessage
  }
}

function buildMessage(options?: UnknownApiErrorOptions): string {
  const parts: string[] = []
  if (options?.status !== undefined) {
    parts.push(`status ${options.status}`)
  }
  if (options?.url) {
    parts.push(options.url)
  }
  if (options?.code) {
    parts.push(`code=${options.code}`)
  }
  if (options?.serverMessage) {
    parts.push(`"${options.serverMessage}"`)
  }

  const suffix = parts.length > 0 ? ` (${parts.join(', ')})` : ''
  return `An unknown error occurred${suffix}.`
}
